import ExchangeContainer from './ExchangeContainer';

export default ExchangeContainer;